import * as React from 'react';
import { connect } from 'react-redux';
import * as _ from 'underscore';

import { DataGrid } from '@tableau/data-grid-3-wrapper';
import { MetricValuePill } from '@tableau/metrics-shared-widgets-dom';

import { CommonStyles } from '../../../common/react/CommonStyles';
import { getMeasureFormat, getMetricMeasure } from '../../../metrics';
import { selectMetricDataForContentItem } from '../../../metrics/selectors';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { IMetricDataInfo, isMetricInfo } from '../../../ts/models/IMetricInfo';
import { IExplorableItemTypeInfo } from '../../../ts/models/resourceInfoParts';
import { AppState } from '../../state/AppState';
import { MapStateToProps } from '../../utils/ConnectUtils';

const containerCellStyle: React.CSSProperties = {
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'row',
  paddingTop: CommonStyles.Sizes.MediumSpace,
  alignItems: 'center',
  justifyContent: 'center',
  width: CommonStyles.Sizes.MetricValueCellWidth,
  height: CommonStyles.Sizes.RowHeight,
};

// we have a connected metric value pill so that as metric data comes in and updates, we only re-render the pill,
// not the whole data grid. This is tested in test\src\ts\app\spaces\ListView\DataGridCellsTests.tsx
export interface MetricValuePillWrapperStateProps {
  readonly metricData: IMetricDataInfo;
}

export interface MetricValuePillWrapperOwnProps {
  readonly row: DataGrid.Row;
}

export type MetricValuePillWrapperProps = MetricValuePillWrapperStateProps & MetricValuePillWrapperOwnProps;

export class MetricValuePillWrapper extends React.PureComponent<MetricValuePillWrapperProps> {
  public render() {
    const rowData = this.props.row.data as IExplorableItemTypeInfo;
    if (!isMetricInfo(rowData) || !FeatureFlags.metricsSpaceEnabled) {
      // render blank cell for non-metrics. This happens in mixed content pages.
      return null;
    }

    let measure;
    let format;

    if (this.props.metricData && this.props.metricData.dataPoints && this.props.metricData.dataPoints.length > 0) {
      measure = getMetricMeasure(this.props.metricData);
      format = getMeasureFormat(this.props.metricData);
    }

    return (
      <span style={containerCellStyle}>
        <MetricValuePill value={measure} measureFormat={format} />
      </span>
    );
  }
}


const mapStateToProps: MapStateToProps<MetricValuePillWrapperStateProps> = (state: AppState, ownProps: MetricValuePillWrapperOwnProps) =>({
  metricData: ownProps.row.data?  selectMetricDataForContentItem(state, ownProps.row.data) : {}
});

export const ConnectedMetricValuePillWrapper = connect(mapStateToProps)(MetricValuePillWrapper);
